import React from 'react';
import NavIcon from './NavIcon/NavIcon';
import { faComments, faHouseChimney } from '@fortawesome/free-solid-svg-icons';
// @ts-ignore
import style from './NavIcons.module.scss?module';
import { faStreetView } from '@fortawesome/pro-solid-svg-icons';
import { useUser } from '../../../../Context/UserContext';
import useSupportChatBadge from '../../Hooks/useSupportChatBadge';

const NavIcons = () => {
  const userContext = useUser();

  if (userContext.loading) {
    return null;
  }

  return (
    <span className={style.Icons}>
      <NavIcon
        link="/virtual-trade-show/lobby"
        icon={faHouseChimney}
        text="Lobby"
      />
      {userContext.user && (
        <NavIcon
          link="/virtual-trade-show/exhibition"
          icon={faStreetView}
          text="Exhibition"
        />
      )}
      {userContext.user ? (
        <HelpCenterNavIcon />
      ) : (
        <NavIcon
          link="/virtual-trade-show/help-center"
          icon={faComments}
          text="Help Center"
        />
      )}
    </span>
  );
};

const HelpCenterNavIcon = () => {
  const { hasUnread } = useSupportChatBadge();
  return (
    <NavIcon
      link="/virtual-trade-show/help-center"
      icon={faComments}
      text="Help Center"
      badge={hasUnread}
    />
  );
};

export default NavIcons;
